import { FC, useContext } from 'react'

import { Cluster, IconButton, Typography } from '@forto-dev/phoenix-ui-core'

import { ThemeContext } from '@/utils/theme'
import { isEnabled } from '@/utils/toggles'

import { useLocalisation } from '../utils/localisation'

export const Footer: FC = () => {
  const { theme, setTheme } = useContext(ThemeContext)
  const { translate } = useLocalisation()
  return (
    <>
      <Typography variant="body">{translate('footer.copyright', { year: new Date().getFullYear() })}</Typography>
      <Cluster gap={16}>
        <IconButton
          icon="LinkedIn"
          label="LinkedIn"
          onClick={() => window.open('https://www.linkedin.com/company/fortocompany', '_blank', 'noopener,noreferrer')}
        />
        {isEnabled('themeSwitcher') ? (
          <IconButton
            icon={theme === 'dark' ? 'Light' : 'Dark'}
            label={theme === 'dark' ? 'Light mode' : 'Dark mode'}
            onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
          />
        ) : null}
      </Cluster>
    </>
  )
}
